import { useMemo } from 'react';

type Score = {
  value: number;
  future: number;
  past: number;
  health: number;
  dividend: number;
} | null;

export const useNormalisedCompanySnowflakeScore = (
  score: Score
): [number, number, number, number, number] => {
  return useMemo(() => {
    const {
      value = 0,
      future = 0,
      past = 0,
      health = 0,
      dividend = 0,
    } = score || {};
    return [value + 1, future + 1, past + 1, health + 1, dividend + 1];
  }, [score]);
};
